import { HttpClient } from '@angular/common/http';
import { Component, inject, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { combineLatest, concatMap, forkJoin, of, Subject, Subscription } from 'rxjs';
import { ContractGuard } from 'src/app/core/guards/contract.guard';
import { filter, map } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { OktaUserProfile, UserClaims } from 'src/app/model/okta/userClaims';
import { CHAT, CHATGROUP } from '../../../../core/constants/feature-key.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { PocketGeekContent } from '@assurantlabs/content';
import { IImageContainer } from 'src/app/model/sitefinity/IImageContainer';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SnackbarService } from '../../../../core/services/snackbar/snackbar.service';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { EditHomeDeviceDetailsModalComponent } from '../edit-home-device-details-modal/edit-home-device-details-modal.component';
import { DeviceContentApiService } from 'src/app/shared/device-content-api/device-content-api.service';
import { DeviceContentRequestModalWindowComponent } from 'src/app/shared/components/device-content-request-modal-window/device-content-request-modal-window.component';
import { UploadReceiptModalComponent } from '../upload-receipt-modal/upload-receipt.modal.component';
import { GSSPAuthenticationService } from 'src/app/core/services/gssp-authentication.service';
import { ChatHandler } from 'src/app/core/handler/chat-handler';
import { DeviceType } from 'src/app/shared/device/device-type/device-type';
import { DeviceTypeService } from 'src/app/shared/device/device-type/device-type.service';
import { DeviceTypeDto } from 'src/app/core/services/device-inventory/device-type.dto';
import { UpdateDeviceBodyDto } from 'src/app/core/services/device-inventory/update-device-body.dto';
import { MobileDeviceService } from 'src/app/core/services/mobile-device.service';
import { HardwareTestResult } from 'src/app/shared/device/phone-device/hardware-test-result';
import { AccountService } from 'src/app/core/services/account.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ADPResourceService } from 'digital-core';
import { IUploadReceipt } from 'src/app/model/device-inventory/IUploadReceipt';
import { GlobalModalWindowService } from 'src/app/core/services/global-modal-window.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ResumeDiagnosticTestModalComponent } from 'src/app/modules/device-diagnostics/components/resume-diagnostic-test-modal/resume-diagnostic-test-modal.component';
import { ContractDeviceInventories } from 'src/app/core/services/contract-device-inventories';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { UpdateUserInfoDevicesCountDto } from 'src/app/model/account/update-user-info-devices-count.dto';
import { UserInfoReportingService } from 'src/app/core/services/user-info-refporting.service';
import { DeviceDetailsDialogData } from '../device-details-dialog/device-details-dialog-data';
import { DeviceDetailsDialogComponent } from '../device-details-dialog/device-details-dialog.component';
import { GTMDeviceFlow, GTMEvents } from '../../../../model/google-tag-manager/api-status';
import { StorageService } from 'src/app/core/services/storage.service';
import { AsappChatService } from '../../../../core/services/asapp-chat.service';
import { CryptoService } from 'src/app/core/services/cypto/crypto.service';
import { format } from 'date-fns';

interface IUserManualContentItem {
  title: string;
  url: string;
  id: string;
  subCategory: string; // ENERGY_GUIDE, QUICK_START_GUIDE, USER_GUIDE
}

@Component({
  selector: 'app-home-device-details',
  templateUrl: './home-device-details.component.html',
  styleUrls: ['./home-device-details.component.scss'],
})

// TODO: Want to rename this component to DeviceDetailsComponent after we've merged the other 2 components for the mobile plan device types (smartphone, tablets/wearables). Once we've merged those other 2 components' functionality
//  into this component, we'll want to clean up the solution to remove the unused components and probably also remove the inventory v2 component as it will be retired
export class HomeDeviceDetailsComponent implements OnInit, OnDestroy {
  public programCode: string;
  private contractId: string = '';
  private isContractExpired: boolean = false;
  private contractExpiredDate: Date;
  private currentDeviceInventoryId?: number;
  private deviceInventories?: ContractDeviceInventories;
  public devicesFromAllInventories?: DeviceDto[];
  public isDeviceInInventory: boolean = false;
  public isAddDeviceEnabled: boolean = false;
  public isEditDeviceEnabled: boolean = false;
  public hasAccidentalDamageCoverage: boolean = false;
  public hasMechanicalBreakdownCoverage: boolean = false;
  public hasLossTheftCoverage: boolean = false;
  public hasScreenRepairCoverage: boolean = false;
  public hasCoverage: boolean = false;
  public noCoverageSupportTopicList: string[];
  public phonePreTestCoverageList: string[];
  public receiptMenuLabel: string = '';
  public allowReceipts: boolean = false;
  public isDiagnosticsRequiredForGadgetPolicies: boolean = false;
  public requireDiagnosticsOnDevice: boolean = false;
  public deviceContentLoaded: boolean = false;

  public coverageBenefitsReimburementsEnabled: boolean = false;
  public showCoverageDetails: boolean = false;
  public showPhoneGetStarted: boolean = false;
  public showCellularGetStarted: boolean = false;
  public showNoCoverage: boolean = false;
  public showNoCoverageAndNoSupport: boolean = false;

  //coverage section buttons behavior
  public showFileClaimButton: boolean = false;
  public showFileClaimButtonDivider: boolean = false;
  public showSupportButton: boolean = false;
  public showSupportButtonDivider: boolean = false;
  public showClaimsStatusButton: boolean = false;

  //no coverage sectin button behavior
  public showNoCoverageSupportChatButton: boolean = false;

  public tabTitleCoverageBenefits: string = '';
  public tabTitleReimbursement: string = '';

  public deviceNickName: string = '';
  private destroy$ = new Subject<boolean>();
  public userManualList: IUserManualContentItem[] = [];
  public hasTipsandTricksContent: boolean = false;
  public hasHowToGuidesContent: boolean = false;
  public hasUserManualsContent: boolean = false;
  public hasSubmittedContentRequest: boolean = false;
  public deviceType?: DeviceType;
  private deviceTypes: DeviceTypeDto[];
  public selDevice: PghUserDeviceBase;
  public allDevices: PghUserDeviceBase[];
  public isMobileDevice: boolean = false;
  public isSmartPhoneDevice: boolean = false;
  public isTabletDevice: boolean = false;
  public isSmartwatchDevice: boolean = false;
  public deviceIMEI: string = '';
  public devicePhoneNumber: string = '';
  private subscriptions: Subscription[] = [];
  public headerText?: string;
  public deviceLinksLoaded: boolean = false;
  public deviceManualsLoaded: boolean = false;
  public hardwareTestResult: HardwareTestResult;
  public viewTestResults: boolean = false;
  public crackScreenTestFailed: boolean = false;
  public touchScreenTestFailed: boolean = false;
  public frontOfWatchTestFailed: boolean = false;
  public backOfWatchTestFailed: boolean = false;
  public touchScreenFailedTipsList: string[];
  public crackScreenFailedTipsList: string[];
  public imageUploadFailedTipsList: string[];
  public isPrimary: boolean = false;
  public showModal = false;
  public hasServiceFee = false;
  public serviceFeeLabelKey: string = '';

  private isGSSP = false;
  private dealerCode: string;
  private masterCertificateNumber: string;
  private childCertificateNumber: string;
  private contractHasMobileCertificate: boolean;
  private useMobileInventory: boolean = false;
  private coverageTypeCode: string;
  private redirectUrl: string;
  private contractNum: string;
  private zipCode: string;
  private isActive: boolean;

  public WifiCellularEnabledSelectionForm: FormGroup;
  public isWifiSelected: boolean = false;
  public isCellularSelected: boolean = false;
  public isCellularCoverageDetails: boolean = false;

  public isBenefitsSectionEnabled: boolean = false;

  // Benefits Section
  public tab1Arr: any[] = [];
  public tab2Arr: any[] = [];
  public footerSettings: any;

  // P360 Coverage Deductible Fees
  public deductibleMechanicalDamageAmount: string = '';
  public deductibleAccidentalDamageAmount: string = '';
  public deductibleLossTheftAmount: string = '';
  public deductibleScreenDamageAmount: string = '';

  public noCoverageDueToCancelledEprismText: string = '';

  private isSPOEEnabled: boolean;

  readonly OKTA_TOKEN_STORAGE = 'okta-token-storage';

  //TODO: make these real navigation items hooked to sitefinity
  //public deviceLinks: ICtaNavigationItem[];
  //public defaultDeviceLinks: ICtaNavigationItem [];

  // GA variables
  private userEmail: string;
  private userType: string;
  private usersOnContract: number;
  isTechServicesChatEnabled: boolean = false;

  tipsAndTricksImage: IImageContainer;
  howToGuidesImage: IImageContainer;
  coverageBenefitsList: any[] = [];
  reimbursementsList: any[] = [];
  public serialNumber = 'N/A';
  private googleAnalyticsService = inject(GoogleAnalyticsService);

  constructor(
    public httpClient: HttpClient,
    private selectedDeviceService: SelectedDeviceService,
    private contentApiService: DeviceContentApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackbarService,
    private loggedInUserSettings: LoggedInUserSettings,
    private sanitizer: DomSanitizer,
    private deviceInventoryService: DeviceInventoryService,
    private dialog: MatDialog,
    private requestContentDialog: MatDialog,
    private contractGuard: ContractGuard,
    private gsspAuthService: GSSPAuthenticationService,
    private deviceTypeService: DeviceTypeService,
    private mobileDeviceService: MobileDeviceService,
    private accountService: AccountService,
    private utilityService: UtilityService,
    public resourceService: ADPResourceService,
    private globalModalWindowService: GlobalModalWindowService,
    private userInfoReportingService: UserInfoReportingService,
    private storageService: StorageService,
    public title: Title,
    private asappChatService: AsappChatService,
    private cryptoService: CryptoService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.viewTestResults = params['viewTestResults'] ? true : false;
    });
  }

  ngOnInit() {
    let pageTitle = this.resourceService.getPortalLabel('Global_DeviceDetails_Title').Value;
    let programName = this.resourceService.getPortalSetting('Global_ProgramName').Value;
    this.isSPOEEnabled = this.resourceService.isPortalSettingTrue('Global_SPOE_Enabled');

    this.title.setTitle(pageTitle + ' | ' + programName);

    this.programCode = this.resourceService.getPortalSetting('Global_ProgramCode').Value;
    this.coverageBenefitsReimburementsEnabled = this.resourceService.isPortalSettingTrue('Global_DeviceDetails_Benefits_Enabled');
    this.touchScreenFailedTipsList = this.resourceService.getPortalSetting('DeviceDetails_TouchScreenFailedTips_List')?.Value?.split(';');
    this.crackScreenFailedTipsList = this.resourceService.getPortalSetting('DeviceDetails_CrackedScreenFailedTips_List')?.Value?.split(';');
    this.imageUploadFailedTipsList = this.resourceService.getPortalSetting('DeviceDetails_ImageUploadFailedTips_List')?.Value?.split(';');
    this.noCoverageSupportTopicList = this.resourceService
      .getPortalSetting('DeviceDetails_NoCoverage_SupportTopic_List')
      ?.Value?.split(';');
    this.phonePreTestCoverageList = this.resourceService.getPortalSetting('DeviceDetails_PhonePreTest_Coverage_List')?.Value?.split(';');
    this.isDiagnosticsRequiredForGadgetPolicies = this.resourceService.isPortalSettingTrue(
      'Global_Diagnostics_Required_For_Gadget_Policies'
    );
    this.isBenefitsSectionEnabled = this.resourceService.isPortalSettingTrue('Global_DeviceDetails_Benefits_Enabled');
    this.showModal =
      this.activatedRoute?.snapshot?.paramMap?.get('noDevice') != 'true' &&
      this.resourceService.isPortalSettingTrue('DeviceDetails_ShowModal_On_AddDevice');
    this.headerText = this.activatedRoute?.snapshot?.data?.headerText ?? '';

    this.tabTitleCoverageBenefits = this.resourceService.getPortalLabel('DeviceDetails_Benefits_Tab_Coverage_Title').Value;
    this.tabTitleReimbursement = this.resourceService.getPortalLabel('DeviceDetails_Benefits_Tab_Reimbursement_Title').Value;
    this.serialNumber = this.resourceService.getPortalLabel('DeviceDetails_SerialNumber_NA').Value;

    // temp get Terms of Services url link for benefits footer section, will need to replace with Terms of Conditions
    this.resourceService.getPortalMenus('Footer_Menu').subscribe((data) => {
      this.footerSettings = data.MenuItems.filter((x) => x.Caption === 'Terms of Service');
    });

    this.WifiCellularEnabledSelectionForm = new FormGroup({
      selectedWifiCellularEnabled: new FormControl('', Validators.required),
    });

    const joined$ = combineLatest([this.loggedInUserSettings.$selectedContract, this.loggedInUserSettings.$userClaims]).pipe(
      filter(([a, b]) => a !== null && b !== null)
    );

    joined$.subscribe(([contract, userClaims]: [ISelectedContract, UserClaims]) => {
      this.contractId = contract.id;
      this.isActive = this.contractGuard.activateGuard(contract, true, true, false);
      this.isGSSP = contract.useGSSPClaims;
      this.masterCertificateNumber = contract?.id;
      this.childCertificateNumber = contract?.certificateNumberForGadgetsPolicy;
      this.contractHasMobileCertificate = contract?.certificateNumberForPhonesPolicy != null;
      this.dealerCode = contract.dealerId;
      this.coverageTypeCode = 'AD';
      this.zipCode = contract?.zipCode;
      this.contractNum = contract && contract?.members && contract?.members.length ? contract?.members[0].contractNumber : '';
      this.isPrimary = contract?.isPrimary;
      this.userEmail = userClaims.email;
      this.userType = this.isPrimary ? 'Primary' : 'Secondary';
      this.usersOnContract = contract.members.length;
      this.isContractExpired = contract.isExpired;
      this.contractExpiredDate = contract.cancellationDate;

      this.isTechServicesChatEnabled =
        this.loggedInUserSettings.isFeatureEnabled(contract.dealerId, CHATGROUP) &&
        this.loggedInUserSettings.isFeatureEnabled(contract.dealerId, CHAT);

      this.selDevice = this.selectedDeviceService.getSelectedDevice();
      if (this.selDevice.serialNumber != null && this.selDevice.serialNumber != '') this.serialNumber = this.selDevice.serialNumber;

      //if this client site will show coverage/benefits and reimbursements (CBR) tabs rather than the traditional coverage section, need to retrieve
      //the lists of these CBRs to display in the coverage section of the page
      if (this.coverageBenefitsReimburementsEnabled) {
        this.coverageBenefitsList = this.getCBRItemsByCategoryKey(`CBR_DeviceType_List_${this.selDevice.deviceTypeCode}_CoverageBenefits`);
        this.reimbursementsList = this.getCBRItemsByCategoryKey(`CBR_DeviceType_List_${this.selDevice.deviceTypeCode}_Reimbursement`);
      }
      //The three potentially cellular enabled device types that may require diagnostics and have different behavior than gadget devices. Using these clear variables throughout
      //the code for better readability and to clarify the logic
      this.isTabletDevice = this.selDevice?.deviceTypeCode === 'TABL';
      this.isSmartwatchDevice = this.selDevice?.deviceTypeCode === 'SMAR';
      this.isSmartPhoneDevice = this.selDevice?.deviceTypeCode === 'SMPH';

      this.isMobileDevice = this.isSmartPhoneDevice && contract.certificateNumberForPhonesPolicy != null;

      if(this.selDevice?.deviceSource == 'EPRISM' && this.isSmartPhoneDevice){
        this.isMobileDevice = true;
      }

      if ((this.isTabletDevice || this.isSmartwatchDevice || this.isSmartPhoneDevice) && this.contractHasMobileCertificate) {
        this.useMobileInventory = true;
      }

      //when device type is a diagnostic capable device (smartphone, smartwatch, tablet), the client may require diagnostics on the device in order to
      //have coverage. Check for the mobile certificate on the contract or if the client has been configured to require diagnostics on these devices in the gadget inventory
      if (
        (this.isTabletDevice || this.isSmartwatchDevice || this.isSmartPhoneDevice) &&
        (this.contractHasMobileCertificate || this.isDiagnosticsRequiredForGadgetPolicies)
      ) {
        this.requireDiagnosticsOnDevice = true;
      }
      if (this.resourceService.isPortalSettingTrue('DeviceDetails_ServiceFee_Enabled') && this.selDevice.deviceSource !== 'EPRISM') {
        this.getServiceFeesForDeviceTypes();
      }

      this.loadInventoryInformation();
    });

    this.setCoverageSectionButtonsVisibility();
    this.receiptMenuLabel = this.selectedDeviceService?.getSelectedDevice()?.hasReceipt
      ? this.resourceService.getPortalLabel('DeviceDetails_Menu_View_Receipt_Label')?.Value
      : this.resourceService.getPortalLabel('DeviceDetails_Menu_Upload_Receipt_Label')?.Value;
    // TODO Scroll does not work on mobile view on this component, need to test more
    window.scrollTo(0, 0);

    const gtmFlow = this.isAddDeviceEnabled ? GTMDeviceFlow.AddDevice : GTMDeviceFlow.EditDevice;

    this.googleAnalyticsService.emitDeviceInventoryEvent(
      GTMEvents.DeviceInventoryAddView,
      gtmFlow,
      this.selDevice.deviceTypeName,
      this.selDevice.make,
      this.selDevice.model
    );
  }

  ngOnDestroy() {
    document.documentElement.className = '';
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  isCoveredCellularDevice(inventoryId: number, deviceTypeCode: string) {
    return this.deviceInventoryService.getDeviceTypes(inventoryId, true).pipe(
      map((deviceTypes) => {
        return deviceTypes.find((dt) => dt.code === deviceTypeCode) != null;
      })
    );
  }

  private async loadInventoryInformation() {
    this.accountService.getAllInventoriesWithDevicesForSelectedContract(this.destroy$).subscribe({
      next: (inventories) => {
        this.deviceInventories = inventories;

        this.devicesFromAllInventories = [
          ...(inventories?.cellularEnabledPolicyInventory?.devices ?? []),
          ...(inventories?.gadgetPolicyInventory?.devices ?? []),
          ...(inventories?.gadgetClientSoldPolicyInventory?.devices ?? []),
          ...(this.deviceInventoryService?.getEprismDevices()),
        ];
        forkJoin([
          this.selDevice.deviceSource == 'EPRISM' ? of(null) : this.deviceInventoryService.getDeviceTypes(inventories?.cellularEnabledPolicyInventory?.info?.id),
          this.selDevice.deviceSource == 'EPRISM' ? of(null) : this.deviceInventoryService.getDeviceTypes(inventories?.gadgetPolicyInventory?.info?.id),
          this.selDevice.deviceSource == 'EPRISM' ? of(null) : this.deviceInventoryService.getDeviceTypes(inventories?.gadgetClientSoldPolicyInventory?.info?.id),
        ]).subscribe({
          next: ([mobileInventoryTypes, gadgetsInventoryTypes, clientSoldInventoryTypes]: [
            DeviceTypeDto[],
            DeviceTypeDto[],
            DeviceTypeDto[],
          ]) => {
            if (this.selDevice.deviceSource == 'EPRISM') {
              this.deviceType = {
                code: this.selDevice.deviceTypeCode,
                displayName: this.selDevice.deviceTypeName,
                imageKey: null,
                id: null
              };
            } else if (this.selDevice.inventoryId) {
              this.currentDeviceInventoryId = this.selDevice.inventoryId;
              this.deviceTypes =
                this.selDevice.inventoryId === this.deviceInventories.gadgetPolicyInventory?.info?.id
                  ? gadgetsInventoryTypes
                  : this.selDevice.inventoryId === this.deviceInventories.gadgetClientSoldPolicyInventory?.info?.id
                    ? clientSoldInventoryTypes
                    : mobileInventoryTypes;
            }
            //if selected device will be placed in the gadgets inventory, set current inventory to gadgets inventory and set device types to those for gadgets
            else if (!this.useMobileInventory) {
              if (this.selDevice.buyType?.toLowerCase() == 'yes') {
                this.currentDeviceInventoryId = this.deviceInventories.gadgetClientSoldPolicyInventory?.info?.id;
                this.deviceTypes = clientSoldInventoryTypes;
              } else {
                this.currentDeviceInventoryId = this.deviceInventories.gadgetPolicyInventory?.info?.id;
                this.deviceTypes = gadgetsInventoryTypes;
              }
            }
            //if selected device will be placed in the mobile inventory, set current inventory to mobile inventory and set device types to those for cellular enabled devices
            else {
              this.currentDeviceInventoryId = this.deviceInventories.cellularEnabledPolicyInventory?.info?.id;
              this.deviceTypes = mobileInventoryTypes;
            }
            this.allDevices = this.selectedDeviceService.getAllDevices();

            this.loadDeviceContent();
            this.deviceContentLoaded = true;
          },
          error: (error) => {
            throw error;
          },
        });
      },
      error: (error) => {
        throw error;
      },
    });
  }

  private loadDeviceContent() {
    if ((this.isSmartPhoneDevice || this.isTabletDevice || this.isSmartwatchDevice) && this.viewTestResults) {
      this.getDeviceDiagnosticTests();
    }
    this.getDeviceDetails(this.deviceTypes);
    this.getDeviceUserManuals();
  }
  getDeviceDetails(deviceTypes: DeviceTypeDto[]) {
    this.deviceType = this.deviceTypeService.getDeviceTypeByCodeOrDefault(this.selDevice.deviceTypeCode, {
      displayName: this.selDevice.deviceTypeName,
    });

    if (this.selDevice.coverage != null) {
      this.hasMechanicalBreakdownCoverage = this.selDevice.coverage.hasMechanicalDamage ?? false;
      this.hasAccidentalDamageCoverage = this.selDevice.coverage.hasAccidentalDamage ?? false;
      this.hasLossTheftCoverage = this.selDevice.coverage.hasTheft ?? false;
      this.hasScreenRepairCoverage = this.selDevice.coverage.hasScreenDamage ?? false;

      if(this.selDevice.deviceSource === 'EPRISM' && this.selDevice.deductibleAmounts != null){

        this.deductibleMechanicalDamageAmount = this.selDevice.deductibleAmounts.mechanicalDamageAmount ?? undefined;
        if(this.deductibleMechanicalDamageAmount !== undefined){
           this.deductibleMechanicalDamageAmount = this.resourceService.getViewLabel('DeviceDetails_ServiceFee_Deductible_Description').replace('{0}', this.deductibleMechanicalDamageAmount);
        }else{
            this.deductibleMechanicalDamageAmount = this.resourceService.getViewLabel('DeviceDetails_NoServiceFee_Deductible_Description');
        }

        this.deductibleAccidentalDamageAmount = this.selDevice.deductibleAmounts.accidentalDamageAmount ?? undefined;
        if(this.deductibleAccidentalDamageAmount !== undefined){
           this.deductibleAccidentalDamageAmount = this.resourceService.getViewLabel('DeviceDetails_ServiceFee_Deductible_Description').replace('{0}', this.deductibleAccidentalDamageAmount);
        }else{
            this.deductibleAccidentalDamageAmount = this.resourceService.getViewLabel('DeviceDetails_NoServiceFee_Deductible_Description');
        }

        this.deductibleLossTheftAmount = this.selDevice.deductibleAmounts.lossTheftAmount ?? undefined;
        if(this.deductibleLossTheftAmount !== undefined){
           this.deductibleLossTheftAmount = this.resourceService.getViewLabel('DeviceDetails_ServiceFee_Deductible_Description').replace('{0}', this.deductibleLossTheftAmount);
        }else{
           this.deductibleLossTheftAmount = this.resourceService.getViewLabel('DeviceDetails_NoServiceFee_Deductible_Description');
        }

        this.deductibleScreenDamageAmount = this.selDevice.deductibleAmounts.screenDamageAmount ?? undefined;
        if(this.deductibleScreenDamageAmount !== undefined){
           this.deductibleScreenDamageAmount = this.resourceService.getViewLabel('DeviceDetails_ServiceFee_Deductible_Description').replace('{0}', this.deductibleScreenDamageAmount);
        }else{
           this.deductibleScreenDamageAmount = this.resourceService.getViewLabel('DeviceDetails_NoServiceFee_Deductible_Description');
        }
      }
    } else {
      const foundType = deviceTypes.find((dt) => dt.code === this.selDevice?.deviceTypeCode);
      this.hasMechanicalBreakdownCoverage = foundType?.coverages?.hasMechanicalDamage ?? false;
      this.hasAccidentalDamageCoverage = foundType?.coverages?.hasAccidentalDamage ?? false;
      this.hasLossTheftCoverage = foundType?.coverages?.hasTheft ?? false;
    }

    if (this.hasMechanicalBreakdownCoverage || this.hasAccidentalDamageCoverage || this.hasLossTheftCoverage) {
      this.hasCoverage = true;
      this.allowReceipts = this.resourceService.isPortalSettingTrue('DeviceDetails_AllowReceipts') && this.hasCoverage;
    } else if (this.selDevice.deviceSource == 'EPRISM' && this.isContractExpired) {
      const contractExpiredAccessPeriod = Number(this.resourceService.getPortalSetting('Dashboard_ContractExpired_Eprism_Access_Period').Value);
      var cancelDate = new Date(this.contractExpiredDate);
      cancelDate.setDate(cancelDate.getDate() + contractExpiredAccessPeriod);
      const endDateStr = format(cancelDate, 'MM/dd/yyyy');
      this.noCoverageDueToCancelledEprismText = this.resourceService.getPortaLabelValue('DeviceDetails_No_Coverage_Cancelled_Eprism_Text');
      this.noCoverageDueToCancelledEprismText = this.noCoverageDueToCancelledEprismText.replace('{endDate}', endDateStr);
    }
    if (this.selDevice.deviceId === null || this.selDevice.deviceId === undefined) {
      this.isDeviceInInventory = false;
      this.isAddDeviceEnabled = true;
      this.isEditDeviceEnabled = false;
    } else {

      if(this.selDevice.deviceSource === 'EPRISM'){
        this.isEditDeviceEnabled = false;
        // change device icon to single phone icon from default for eprism smartphone device
        if(this.deviceType.code === 'SMPH'){
          this.deviceType.imageKey = 'smartphone-2tone'
        }
      }
      else{
        this.isEditDeviceEnabled = true;
      }

      this.isDeviceInInventory = true;
    }

    //set the details section
    //if mobile device and not yet added to the inventory, show the get started information text
    if (this.isSmartPhoneDevice && this.requireDiagnosticsOnDevice && !this.isDeviceInInventory) {
      this.showPhoneGetStarted = true;
    } else if ((this.isTabletDevice || this.isSmartwatchDevice) && this.requireDiagnosticsOnDevice && !this.isDeviceInInventory) {
      this.showCellularGetStarted = true;
    }
    //if device has coverage (home devices and added mobile devices), show the coverage information for device
    else if (this.hasCoverage) {
      this.showCoverageDetails = true;
    }
    //if device has no coverage, show no coverage text
    else {
      if (this.isTechServicesChatEnabled) this.showNoCoverage = true;
      else this.showNoCoverageAndNoSupport = true;
    }
  }

  setCoverageSectionButtonsVisibility() {
    //coverage section buttons
    //file claim/claims & support button
    if (
      (this.isPrimary && this.resourceService.isPortalSettingTrue('DeviceDetails_FileClaimButtonEnabledPrimary')) ||
      (!this.isPrimary && this.resourceService.isPortalSettingTrue('DeviceDetails_FileClaimButtonEnabledSecondary'))
    ) {
      this.showFileClaimButton = true;
    }
    //support button
    if (
      this.isTechServicesChatEnabled &&
      ((this.isPrimary && this.resourceService.isPortalSettingTrue('DeviceDetails_SupportButtonEnabledPrimary')) ||
        (!this.isPrimary && this.resourceService.isPortalSettingTrue('DeviceDetails_SupportButtonEnabledSecondary')))
    ) {
      this.showSupportButton = true;
    }
    //view claims status button
    if (
      (this.isPrimary && this.resourceService.isPortalSettingTrue('DeviceDetails_ClaimsStatusButtonEnabledPrimary')) ||
      (!this.isPrimary && this.resourceService.isPortalSettingTrue('DeviceDetails_ClaimsStatusButtonEnabledSecondary'))
    ) {
      this.showClaimsStatusButton = true;
    }
    //display dividers if necessary
    if ((this.showFileClaimButton && this.showSupportButton) || (this.showFileClaimButton && this.showClaimsStatusButton)) {
      this.showFileClaimButtonDivider = true;
    }
    if (this.showSupportButton && this.showClaimsStatusButton) {
      this.showSupportButtonDivider = true;
    }
    //no coverage section button
    if (
      (this.isPrimary && this.resourceService.isPortalSettingTrue('DeviceDetails_SupportChatButtonEnabledPrimary')) ||
      (!this.isPrimary && this.resourceService.isPortalSettingTrue('DeviceDetails_SupportChatButtonEnabledSecondary'))
    ) {
      this.showNoCoverageSupportChatButton = true;
    }
  }

  //Retreives the list of coverage/benefits or reimbursments (CBR) for the device type of the selected device
  //Each CBR item consits of a title, body, and icon. The 2 different categories of CBR (coverage/benefits or reimbursments) are shown in 2 tabs
  private getCBRItemsByCategoryKey(key: string): any[] {
    let deviceTypeCBRList = this.resourceService.getPortaLabelValue(key)?.split(';');
    let cbrList: any[] = [];
    for (const item of deviceTypeCBRList) {
      let cbrItem = {
        cbrName: item,
        titleKey: item + '_Title',
        bodyKey: item + '_Body',
        iconKey: 'Global_' + item + '_Icon',
      };
      cbrList.push(cbrItem);
    }
    return cbrList;
  }

  private getServiceFeesForDeviceTypes(){
    let serviceFeesKeyList = this.resourceService.getPortalSetting('DeviceDetails_ServiceFee_List_Keys')?.Value.split(';');
    for(let item of serviceFeesKeyList){
        let serviceFeesDeviceTypeList = this.resourceService.getPortaLabelValue('DeviceDetails_' + item + '_DeviceType_List')?.split(';');
         if(serviceFeesDeviceTypeList.find(x => x === this.selDevice.deviceTypeCode)) {
            this.serviceFeeLabelKey  =  'DeviceDetails_' + item + '_Label';
            this.hasServiceFee = true;
            break;
         }
    }
  }

  async getDeviceUserManuals() {
    const categories: PocketGeekContent.ContentItemCategory[] = [
      PocketGeekContent.ContentItemCategory.MANUALS,
      PocketGeekContent.ContentItemCategory.LIFESTYLE,
      PocketGeekContent.ContentItemCategory.VIDEOS,
    ];
    const device: PocketGeekContent.Device = {
      brand: this.selDevice.make,
      model: this.selDevice.model,
    };

    try {
      const contentItems = await this.contentApiService.getDeviceContent(device, categories);
      let index = 0;
      const manualListArray = new Array();

      for (const contentItem of contentItems) {
        // check to see if device has Tips and Tricks
        if (contentItem.category === PocketGeekContent.ContentItemCategory.LIFESTYLE) {
          this.hasTipsandTricksContent = true;
        }

        // check to see if device has How to Guides
        if (contentItem.category === PocketGeekContent.ContentItemCategory.VIDEOS) {
          this.hasHowToGuidesContent = true;
        }

        if (contentItem.category === PocketGeekContent.ContentItemCategory.MANUALS) {
          this.hasUserManualsContent = true;
          manualListArray.push([]);
          manualListArray[index].url = contentItem.url;
          manualListArray[index].title = contentItem.title;
          manualListArray[index].id = contentItem.id;
          manualListArray[index].subCategory = contentItem.subCategory;
          index++;
        }
      }
      this.userManualList = manualListArray;
      this.deviceManualsLoaded = true
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  //-- begin device management methods --

  // this method is not in use as lowes changed the requirement but we are keeping it in case if this comes back in use
  showAddDeviceModal() {
    const formFieldsArray = this.resourceService.getViewLabel('DeviceDetails_Modal_AddDevice_FormFields_List');
    const dialogData: DeviceDetailsDialogData = {
      title: '',
      message: '',
      cancelButtonText: '',
      confirmButtonText: '',
      inventoryId: null,
      clientSoldInventoryId: null,
      devices: [],
      phoneInventoryId: null,
      phoneDevices: [],
      formFields: formFieldsArray.split('|'),
      selectedDevice: this.selDevice,
    };

    const deviceDetailsDialog = this.dialog.open<DeviceDetailsDialogComponent, DeviceDetailsDialogData, boolean>(
      DeviceDetailsDialogComponent,
      {
        data: dialogData,
        panelClass: 'device-details-dialog-container',
      }
    );

    this.subscriptions.push(
      deviceDetailsDialog.afterClosed().subscribe({
        next: (result) => {
          if (result === true) {
            // this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue("DeviceDetails_AddDevice_Success_Message"));
            this.handleAddDevice();
          }
        },
      })
    );
  }

  // add device to inventory
  public handleAddDevice() {
    if (!this.selDevice.nickName) {
      this.selDevice.nickName = this.setNickname();
    }
    const deviceData = this.deviceInventoryService.buildCreateDeviceBodyDtoFromPghUserDeviceBase(
      this.selDevice,
      this.currentDeviceInventoryId,
      'ESS'
    );

    this.deviceInventoryService.createDevice(deviceData).subscribe({
      next: (device) => {
        const addedDevice = this.deviceInventoryService.buildPghUserDeviceBaseFromDeviceDto(device);
        const foundType = this.deviceTypes.find((dt) => dt.code === this.selDevice?.deviceTypeCode);
        addedDevice.coverage.hasMechanicalDamage = foundType?.coverages?.hasMechanicalDamage ?? false;
        addedDevice.coverage.hasAccidentalDamage = foundType?.coverages?.hasAccidentalDamage ?? false;

        this.selectedDeviceService.setSelectedDevice(addedDevice);
        // addedDevice sometimes returned with a different Make so do not add to the SelectedDeviceService
        this.selDevice.deviceId = addedDevice.deviceId;
        this.selectedDeviceService.updateAllDevices(this.selDevice);

        this.isDeviceInInventory = true;
        this.isEditDeviceEnabled = true;
        this.isAddDeviceEnabled = false;

        this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue('DeviceDetails_AddDevice_Success_Message'));

        // update the user's inventory device count in the UserInfo db
        const updateUserInfoDevicesCountDto: UpdateUserInfoDevicesCountDto = {
          EmailAddress: this.userEmail,
          DeviceCount: this.selectedDeviceService.getAllDevices().length,
        };
        this.userInfoReportingService.updateUserInfoDevicesCount(updateUserInfoDevicesCountDto).subscribe({
          error: (err) => {
            throw err;
          },
        });

        this.googleAnalyticsService.emitDeviceInventoryEvent(
          GTMEvents.DeviceInventoryAddComplete,
          GTMDeviceFlow.AddDevice,
          this.selDevice.deviceTypeName,
          this.selDevice.make,
          this.selDevice.model
        );
      },
      error: (error) => {
        this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue('DeviceDetails_AddDevice_Error_Message'));
        // Emit device inventory add fail event
        this.googleAnalyticsService.emitDeviceInventoryEvent(
          GTMEvents.DeviceInventoryAddFail,
          GTMDeviceFlow.AddDevice,
          this.selDevice.deviceTypeName,
          this.selDevice.make,
          this.selDevice.model
        );
        throw error; //new Error("GraphQL" + error.error.errors[0].message);
      },
    });
  }

  public handleStartRegisterPhoneNumber() {
    this.router.navigate(['phone-registration']);
  }

  public handleStartRegisterCellularEnabled() {
    const deviceTypeCode: string = this.selDevice?.deviceTypeCode;
    if (this.isTabletDevice) {
      this.router.navigate(['tablet-registration']);
    } else if (this.isSmartwatchDevice) {
      this.router.navigate(['smartwatch-registration']);
    }
  }

  // edit device already in inventory
  public handleEditDevice() {
    const isEprism = this.storageService.getLocal<string>(`IsEprismOnly`);
    if (isEprism == 'true') {
      return;
    }
    const oldNickname = this.selDevice.nickName;
    this.selDevice = this.selectedDeviceService.getSelectedDevice();
    const deviceToUpdate = this.selDevice;

    if (deviceToUpdate?.deviceId == null) {
      console.error(`Didn't find the device to update.`);
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.ariaLabel = this.resourceService.getPortalLabel('Global_EditDevice_ARIA_Label').Value;
    dialogConfig.data = {
      make: this.selDevice.make,
      model: this.selDevice.model,
      nickName: this.selDevice.nickName,
      deviceTypeDisplayName: this.deviceType?.displayName,
      submitButtonLabel: 'DeviceDetails_EditFormSubmit_Button_Label',
      cancelButtonLabel: 'Global_Button_Cancel',
      uniqueNicknameErrorMessage: this.resourceService.getPortaLabelValue('DeviceDetails_EditFormUniqueNicknameErrMessage'),
    };

    const dialogRef = this.dialog.open(EditHomeDeviceDetailsModalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      // received data from dialog-component
      if (res.data === 'success') {
        const newNickName = this.selectedDeviceService.getSelectedDevice().nickName;

        const deviceUpdateDetails: UpdateDeviceBodyDto = {
          id: deviceToUpdate.deviceId,
          inventoryId: this.selDevice.inventoryId,
          nickName: newNickName,
        };

        this.deviceInventoryService.updateDevice(deviceUpdateDetails).subscribe({
          next: (value) => {
            this.selDevice.nickName = newNickName;
            this.deviceNickName = newNickName;
            this.selectedDeviceService.updateAllDevices(this.selDevice);
            this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue('DeviceDetails_EditDevice_Success_Message'));
            this.googleAnalyticsService.emitDeviceInventoryEvent(
              GTMEvents.DeviceInventoryAddComplete,
              GTMDeviceFlow.EditDevice,
              this.selDevice.deviceTypeName,
              this.selDevice.make,
              this.selDevice.model
            );

            this.accountService.getAllInventoriesWithDevicesForSelectedContract(this.destroy$).subscribe({
              next: (inventories) => {
                this.devicesFromAllInventories = [
                  ...(inventories?.cellularEnabledPolicyInventory?.devices ?? []),
                  ...(inventories?.gadgetPolicyInventory?.devices ?? []),
                  ...(inventories?.gadgetClientSoldPolicyInventory?.devices ?? []),
                  ...(this.deviceInventoryService?.getEprismDevices()),
                ];
                this.selectedDeviceService.setAllDevices(
                  (this.devicesFromAllInventories ?? []).map((x) => this.deviceInventoryService.buildPghUserDeviceBaseFromDeviceDto(x))
                );
              },
              error: (error) => {
                throw error;
              },
            });
          },
          error: (error) => {
            this.selDevice.nickName = oldNickname;
            this.selectedDeviceService.setSelectedDevice(this.selDevice);
            this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue('DeviceDetails_EditDevice_Error_Message'));
            this.googleAnalyticsService.emitDeviceInventoryEvent(
              GTMEvents.DeviceInventoryAddFail,
              GTMDeviceFlow.EditDevice,
              this.selDevice.deviceTypeName,
              this.selDevice.make,
              this.selDevice.model
            );
            throw error;
          },
        });
      }
    });
  }

  // remove device from inventory
  public handleRemoveDevice() {
    const isEprism = this.storageService.getLocal<string>(`IsEprismOnly`);
    if (isEprism == 'true') {
      return;
    }

    this.selDevice = this.selectedDeviceService.getSelectedDevice();
    const deviceToRemove = this.selDevice;

    if (deviceToRemove?.deviceId == null) {
      console.error(`Didn't find the device to remove.`);
      return;
    }

    let phoneNumber: string = deviceToRemove?.lineNumber ?? '';
    let device: string = ((deviceToRemove?.make ?? '') + ' ' + (deviceToRemove?.model ?? '')).trim();
    const contextData = { PhoneNumber: phoneNumber, Device: device };

    const dialogData: ConfirmationDialogData = {
      title: this.isMobileDevice ? 'DeviceDetails_RemovePhone_Modal_Title' : 'DeviceDetails_RemoveDevice_Modal_Title',
      message: this.isMobileDevice ? 'DeviceDetails_RemovePhone_Modal_Message' : 'DeviceDetails_RemoveDevice_Modal_Message',
      cancelButtonText: 'Global_Button_Cancel',
      confirmButtonText: 'DeviceDetails_RemovePhone_Modal_Submit_Button_Label',
      isPhoneDeviceView: this.isMobileDevice,
      phoneNumber: this.isMobileDevice ? deviceToRemove.lineNumber : null,
      contextData: contextData,
    };

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData,
    });
    this.subscriptions.push(
      confirmationDialog.afterClosed().subscribe({
        next: (result) => {
          if (result.toString().toLowerCase() === 'true') {
            // Update the nickname field to a Unique ID (nickname needs to be unique).
            const deviceToUpdate: UpdateDeviceBodyDto = {
              id: deviceToRemove.deviceId,
              inventoryId: deviceToRemove.inventoryId,
              nickName: this.isMobileDevice ? deviceToRemove.nickName + (Math.random() + 1).toString(36).substring(8) : crypto.randomUUID(),
              imei: '',
            };
            this.deviceInventoryService.updateDevice(deviceToUpdate)
              .pipe(
                concatMap((updatedDevice) => this.deviceInventoryService.deleteDevice(deviceToRemove.deviceId, deviceToRemove.inventoryId))
              )
              .subscribe({
                next: (value) => {
                  this.selectedDeviceService.removeDeviceFromAllDevices(deviceToRemove);
                  this.snackbarService.showSimpleMessage(
                    this.resourceService.getPortaLabelValue('DeviceDetails_RemovePhone_Modal_Success_Message')
                  );

                  //update the user's inventory device count in the UserInfo db
                  const updateUserInfoDevicesCountDto: UpdateUserInfoDevicesCountDto = {
                    EmailAddress: this.userEmail,
                    DeviceCount: this.selectedDeviceService.getAllDevices().length,
                  };
                  this.userInfoReportingService.updateUserInfoDevicesCount(updateUserInfoDevicesCountDto).subscribe({
                    error: (err) => {
                      throw err;
                    },
                  });
                  this.router.navigate([this.resourceService.getPortalSetting('URL_MyDevices').Value]);

                  this.googleAnalyticsService.emitDeviceInventoryEvent(
                    GTMEvents.DeviceInventoryAddComplete,
                    GTMDeviceFlow.DeleteDevice,
                    deviceToRemove.deviceTypeName,
                    deviceToRemove.make,
                    deviceToRemove.model
                  );
                },
                error: (err) => {
                  this.googleAnalyticsService.emitDeviceInventoryEvent(
                    GTMEvents.DeviceInventoryAddFail,
                    GTMDeviceFlow.DeleteDevice,
                    deviceToRemove.deviceTypeName,
                    deviceToRemove.make,
                    deviceToRemove.model
                  );
                  // Only way to show Custom Error Message to EndUser for now
                  // for GraphQL Calls
                  if (err && err.error && err.error.errors[0].message == 'Claim exists for Device') {
                    err.error.CustomTitle = this.resourceService.getPortaLabelValue('DeviceDetails_RemovePhone_Modal_Error_Title');
                  }
                  throw err;
                },
              });
          }
        },
      })
    );
  }

  //helper method to generate a unique nickname for device
  setNickname(): string {
    let count = 0;
    let nickname = `${this.selDevice?.make ?? ''} ${this.selDevice?.model ?? ''}`.trim();
    // If nickname exists, increment the counter and check again.
    while (this.selectedDeviceService.getAllDevices().find((x) => x?.nickName?.toLowerCase() === nickname?.toLowerCase())) {
      count++;
      nickname = `${this.selDevice?.make ?? ''} ${this.selDevice?.model ?? ''} ${count}`.trim();
    }

    return nickname;
  }

  //-- end device management methods --

  public handleViewClaimStatus() {
    const searchClaimsUrl = this.resourceService.getPortalSetting('URL_ClaimsPortal').Value;
    if (this.isGSSP) {
      if (this.masterCertificateNumber && this.masterCertificateNumber.length > 0) {
        const childCertificateNumbers: [string] = [this.childCertificateNumber];
        this.gsspAuthService.postGenerateGSSPToken(this.dealerCode, this.masterCertificateNumber, childCertificateNumbers, null).subscribe({
          next: (gsspAuthToken: any) => {
            if (gsspAuthToken && gsspAuthToken.length > 0) {
              this.redirectUrl = `${searchClaimsUrl}?accessToken=${gsspAuthToken}`;
              this.redirectUrl = this.sanitizer.sanitize(SecurityContext.URL, this.redirectUrl);
              window.open(this.redirectUrl, '_self');
            } else {
              this.globalModalWindowService.showModalWindowMin(
                'Global_Modal_Error_InvalidGsspAuthToken_Title',
                'GetGsspAuthToken',
                'Modal_Error_Content_ClaimHistory'
              );
            }
          },
        });
      } else {
        this.globalModalWindowService.showModalWindowMin(
          'DeviceDetails_MissingMasterCertificateError_Message',
          'GetGsspAuthToken',
          'Modal_Error_Content_ClaimHistory'
        );
      }
    } else {
      const tokens = JSON.parse(localStorage.getItem(this.OKTA_TOKEN_STORAGE));
      const accessToken =
        tokens.access_token && tokens.access_token.accessToken ? tokens.access_token.accessToken : tokens?.accessToken?.accessToken;
      const hashedQuery = btoa(`cn=${this.contractNum}&zip=${this.zipCode}`);
      if (accessToken.indexOf(' ') >= 0) {
        console.log('invalid token');
      } else {
        this.redirectUrl = `${searchClaimsUrl}?q=${hashedQuery}&token=${accessToken}`;
        this.redirectUrl = this.sanitizer.sanitize(SecurityContext.URL, this.redirectUrl);
        window.open(this.redirectUrl, '_blank');
      }
    }
  }

  public handleFileClaim() {
    let claimsLink = this.resourceService.getPortalSetting('URL_DeviceDetailsClaims_Link')?.Value;
    if (claimsLink?.startsWith('/')) {
      this.router.navigate([claimsLink]);
    }
  }

  public handleChatWithLiveSupport() {
    // Show chat or not available dialog
    const chatHandler = new ChatHandler(this.dialog, this.resourceService, this.utilityService, this.activatedRoute, this.asappChatService);
    chatHandler.openChatInterface();
  }

  public handleLetUsKnow() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'device-content-request-dialog';

    const dialogRef = this.requestContentDialog.open(DeviceContentRequestModalWindowComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      if (res.data && res.data.result === 'success') {
        this.hasSubmittedContentRequest = true;
      }
    });
  }
  public handleViewTipsAndTricks() {
    localStorage.setItem('device-detail-url', '/home-device-details');
    this.router.navigate(['/device-content/tips-and-tricks']);
  }

  public handleViewHowToGuides() {
    localStorage.setItem('device-detail-url', '/home-device-details');
    this.router.navigate(['/device-content/how-to-guides']);
  }

  public handleUploadReceipt() {
    this.selDevice = this.selectedDeviceService.getSelectedDevice();
    const deviceToUpdate = this.selDevice;

    if (deviceToUpdate?.deviceId == null) {
      console.error(`Didn't find the device to update.`);
      return;
    }

    const uploadReceiptConfig: IUploadReceipt = {
      title: 'UploadReceipt_Modal_Title',
      subTitle: 'UploadReceipt_Modal_Subtitle',
      allowUploadReceipts: this.resourceService.isPortalSettingTrue('DeviceDetails_AllowReceipts'),
      uploadButtonLabel: 'UploadReceipt_Modal_UploadButton_Label',
      dragDropLabel: 'UploadReceipt_Modal_DragDrop_Label',
      maxUploadFileSize: this.resourceService.getPortalSetting('DeviceDetails_UploadReceipt_MaxUploadFileSize')?.Value,
      submitButtonLabel: 'Global_Button_Submit',
      allowedFileTypes: this.resourceService.getPortalSetting('DeviceDetails_UploadReceipt_AllowedFileTypes')?.Value,
      allowedFileTypesErrorMessage: 'UploadReceipt_Modal_AllowedFileTypesErrorMessage',
      cancelButtonLabel: 'Global_Button_Cancel',
      maxUploadFileSizeErrorMessage: 'UploadReceipt_Modal_MaxUploadFileSizeErrorMessage',
      receiptUploadedMessage: 'UploadReceipt_Modal_ReceiptUploadedMessage',
      uploadConfirmationMessage: 'UploadReceipt_Modal_UploadConfirmationMessage',
      downloadMessage: 'UploadReceipt_Modal_DownloadMessage',
      viewRecieptOKButtonLabel: 'UploadReceipt_Modal_ViewRecieptOK_Button_Label',
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.ariaLabel = this.resourceService.getPortalLabel('Global_UploadReceipt_ARIA_Label').Value;
    dialogConfig.data = {
      contractId: this.contractId,
      make: this.selDevice.make,
      model: this.selDevice.model,
      nickName: this.selDevice.nickName,
      uploadRecieptPage: uploadReceiptConfig,
    };

    const dialogRef = this.dialog.open(UploadReceiptModalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      // received data from dialog-component
      if (res.data === 'success') {
        this.selDevice.hasReceipt = true;
        this.receiptMenuLabel = this.resourceService.getPortaLabelValue('DeviceDetails_Menu_View_Receipt_Label');
        this.selectedDeviceService.setSelectedDevice(this.selDevice);
      }
    });
  }

  //Mobile device diagnostic testing methods
  public getDeviceDiagnosticTests() {
    //check for serial number or imei number
    let deviceImeiOrSerialNumber: string = '';

    if (this.selDevice.imei != null) {
      deviceImeiOrSerialNumber = this.selDevice.imei;
    } else {
      deviceImeiOrSerialNumber = this.selDevice.serialNumber;
    }

    this.mobileDeviceService.getHardwareTestResults(deviceImeiOrSerialNumber).subscribe({
      next: (result) => {
        this.hardwareTestResult = result;
        let crackScreen = this.hardwareTestResult.tests?.find((x) => x.testDescription == 'Screen Cracks');
        let touchScreen = this.hardwareTestResult.tests?.find((x) => x.testDescription == 'Touch Screen');
        let frontOfWatch = this.hardwareTestResult.tests?.find((x) => x.testDescription == 'Front of Watch');
        let backOfWatch = this.hardwareTestResult.tests?.find((x) => x.testDescription == 'Back of Watch');
        this.crackScreenTestFailed = crackScreen ? !(crackScreen.testResult == 'Passed') : undefined;
        this.touchScreenTestFailed = touchScreen ? !(touchScreen.testResult == 'Passed') : undefined;
        this.frontOfWatchTestFailed = frontOfWatch ? !(frontOfWatch.testResult == 'Passed') : undefined;
        this.backOfWatchTestFailed = backOfWatch ? !(backOfWatch.testResult == 'Passed') : undefined;
      },
    });
  }

  public handleRetakeTest() {
    const deviceId = this.selDevice?.deviceId;
    const deviceInventoryId = this.selDevice?.inventoryId;
    //if smartphone, resend the text for running the diagnostic tests
    if (this.isSmartPhoneDevice) {
      const phoneNumber = this.selDevice?.lineNumber;
      this.accountService
        .registerInvitationToDevice(deviceId, deviceInventoryId, true, this.utilityService.getPhoneNumberForTwilio(phoneNumber))
        .subscribe(
          (res) => {
            this.snackbarService.showSimpleMessage(
              this.resourceService
                .getPortaLabelValue('DeviceDetails_RetakeTest_SentMessage_Success')
                .replace(/{PhoneNumber}/gi, `${phoneNumber ?? ''}`.trim())
            );
          },
          (error) => {
            this.snackbarService.showSimpleMessage(
              this.resourceService
                .getPortaLabelValue('DeviceDetails_RetakeTest_SentMessage_Failed')
                .replace(/{PhoneNumber}/gi, `${phoneNumber ?? ''}`.trim())
            );
          }
        );
    } //if tablet or wearable with diagnostic support, re-generate the QR that will be used to run diagnostics on the device
    else {
      this.accountService.registerInvitationToDevice(deviceId, deviceInventoryId, false).subscribe((res) => {
        let data: any[] = [];
        data.push([]);
        data[0].res = res;

        let deviceInvitationCode = data[0].res.invitationCode;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.ariaLabel = this.resourceService.getPortalLabel('Global_ResumeDiagnostic_ARIA_Label').Value;
        dialogConfig.data = {
          deviceTypeCode: this.selDevice?.deviceTypeCode,
          imei: this.selDevice?.imei,
          invitationCode: deviceInvitationCode,
        };

        const dialogRef = this.dialog.open(ResumeDiagnosticTestModalComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((res) => {});
      });
    }
  }

  handleSPOEClaims(){
    // construct string to encrypt

    if(this.selDevice.deviceSource !== undefined && this.selDevice.deviceSource === 'EPRISM'){
      let eprismContracts = this.storageService.getLocal<any[]>('EprismContracts');
      let oktaUserProfile = this.storageService.getLocal<OktaUserProfile>('okta-user-profile');

      const eContract = eprismContracts.find(x => x.policyIdentifier.mobileNumber == oktaUserProfile.primaryPhone);

      if(eContract && this.selDevice){
        let customerIdentifier = this.selDevice.phoneNumber;
        let zipCode = eContract.policyHolderInfo.zipCode;
        let email = eContract.policyHolderInfo.email;

        const currentDate = new Date();
        let utcIsoString = currentDate.toISOString();

        let stringToEncrypt: string = "";

        stringToEncrypt += "newStandardTimestamp=" + utcIsoString + "|";
        stringToEncrypt += "customerIdentifier=" + customerIdentifier + "|";
        stringToEncrypt += "identifierType=MobileNumber" + "|";
        stringToEncrypt += "customerPath=FileClaim" + "|";
        stringToEncrypt += "zip=" + zipCode + "|";
        stringToEncrypt += "email=" + email + "|";
        stringToEncrypt += "carrierCode=7|myAccount=true";

        this.cryptoService.mwcEncryptData(stringToEncrypt).subscribe(
          res => {
            let mwcUrl = this.resourceService.getPortalSetting("URL_External_MWC_Claims").Value;
            if(mwcUrl)
            {
              let url = mwcUrl + '?token=' + res.encryptedData;
              window.open(url, '_self');
            }
          }
        );
      }
    }
    else{
      // go the default claims-support route
      this.handleFileClaim();
    }

  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }

  public handleViewP360CoverageInformation(){
    this.router.navigate(['/coverage-mobile']);
  }

  public handleViewP360HomeTechCoverageInformation(){
    this.router.navigate(['/coverage-home']);
  }

  public formatPhoneNumber(phoneNumberString: string): string {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phoneNumberString;
  }
}
